export default {
  id: 8,
  title: 'Target #8 - Forking Crazy',
  url: 'https://cssbattle.dev/play/8',
  colors: ['#6592CF', '#060F55'],
  solution:
    '<a a><a b><a c><style>body{background:#6592CF}a{position:fixed;background:#060F55}a[a],a[b]{left:50%;transform:translate(-50%)}a[a]{bottom:0;width:20;height:60}a[b]{bottom:50;width:140;height:140;border-radius:0 0 50% 50%}a[c]{top:50;left:130;width:20;height:110;border-radius:10px;box-shadow:20px 0 #6592CF,40px 0 #060F55,60px 0 #6592CF,80px 0 #060F55,100px 0 #6592CF,120px 0 #060F55}</style>',
}
